import React, { memo } from 'react';
import styled from 'styled-components';
import { SettingsButton } from '../settingsPopup/settingsButton';
import { translate } from '../../../common/translation/translate';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';
import { AuthLazyLoad } from '../signin/authLazyLoad';
import { weatherBugAdsForAdvertisersRoute } from '../../common/utilities/routeHelper';
import { largeMediaQuery } from '../../../common/utilities/sizeHelpers';

export const TopNavigation = memo(withScreenSize(({ isMobile }) => {

    if (isMobile) {
        return null;
    }

    return (
        <Container>
            <ContentWrapper>
                <CorporateLink href='https://www.groundtruth.com/'>GroundTruth</CorporateLink>
                <CorporateLink href={weatherBugAdsForAdvertisersRoute} target='_blank'>{translate('weatherBugAdsForAdvertisers')}</CorporateLink>
                <RightContainer>
                    <NavListItem>
                        <AuthLazyLoad />
                    </NavListItem>
                    <NavListItem>
                        <NavLink href={`${location.origin}/press`} target='_self'>{ translate('press') }</NavLink>
                    </NavListItem>
                    <NavListItem>
                        <NavLink href={`${location.origin}/education`} target='_self'>{ translate('education') }</NavLink>
                    </NavListItem>
                    <NavListItem>
                        <NavLink href='mailto:customerfeedback@weatherbug.com'>{ translate('feedback') }</NavLink>
                    </NavListItem>
                    <NavListItem>
                        <NavLink href='https://www.groundtruth.com/jobs/?job-company=4780'>{ translate('careers') }</NavLink>
                    </NavListItem>
                    <NavListItem>
                        <SettingsButton />
                    </NavListItem>
                </RightContainer>
            </ContentWrapper>
        </Container>
    );
}));

TopNavigation.displayName = 'TopNavigation';

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 30px;
    padding: 6px 0;
    background-color: #2f6f8c;

    @media ${largeMediaQuery} {
        justify-content: center;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    @media ${largeMediaQuery} {
        max-width: calc(1218px + 8%);
        padding-left: 4%;
        padding-right: 4%;
    }
`;

const NavLink = styled.a`
    color: #FFFFFF;
    text-decoration: none;
    font-weight: 400;
    font-size: 14px;
`;

const CorporateLink = styled(NavLink)`
    &::after {
        content: ' • ';
        color: #FFFFFF;
        margin: 0 7px;
    }

    &:last-of-type::after {
        content: '';
    }

    &:first-of-type {
        margin-left: 25px;
        @media ${largeMediaQuery} {
            margin-left: 0px;
        }
    }
`;

const RightContainer = styled.ul`
    display: flex;
    height: 30px;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    margin-right: 8px;
`;

const NavListItem = styled.li`
    &:not(:last-child):after {
        content: '';
        display: inline-block;
        margin: 0 8px;
        width: 3px;
        height: 3px;
        background-color: white;
        border-radius: 50%;
        opacity: .5;
        margin-bottom: 2px;
    }
`;

